"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenWorkbookInDesktopDialogContent = void 0;
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var Localize_1 = require("../gen-src/Localize");
var ButtonsComponent_1 = require("./ButtonsComponent");
var styles = require("./Dialog.styl");
var ExpandoHelpComponent_1 = require("./ExpandoHelpComponent");
var ProtocolHelper_1 = require("./ProtocolHelper");
var OpenWorkbookInDesktopDialogContent = /** @class */ (function (_super) {
    __extends(OpenWorkbookInDesktopDialogContent, _super);
    function OpenWorkbookInDesktopDialogContent(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { hideDialog: false };
        _this.handleCloseClick = _this.handleCloseClick.bind(_this);
        return _this;
    }
    OpenWorkbookInDesktopDialogContent.prototype.componentDidMount = function () {
        ProtocolHelper_1.OpenTableau(this.props.workbookInfo);
    };
    OpenWorkbookInDesktopDialogContent.prototype.render = function () {
        var _this = this;
        var handleContinueClick = function (e) {
            _this.handleCloseClick();
        };
        var buttonsProps = {
            workbookInfo: this.props.workbookInfo,
            handleContinueClick: handleContinueClick,
            handleCloseClick: function (e) { return _this.handleCloseClick(); },
        };
        var dialogContent = (React.createElement("div", { className: styles.DialogContent },
            React.createElement("p", null, Localize_1.Messages.HelpText()),
            React.createElement(ExpandoHelpComponent_1.TextContentComponent, { isServer: true }),
            React.createElement(ButtonsComponent_1.ButtonsComponent, __assign({}, buttonsProps))));
        var dialogProps = {
            children: dialogContent,
            testId: 'open-workbook-in-desktop-dialog',
            showCloseButton: true,
            type: widgets_1.DialogType.NormalWithTitleBar,
            onCloseRequest: this.handleCloseClick,
            positioningBehavior: widgets_1.DialogPositioningBehavior.Centered,
            isModal: false,
            showFooter: false,
            dialogWidth: 500,
        };
        var dialog = this.state.hideDialog ? React.createElement(React.Fragment, null) : React.createElement(widgets_1.DialogWidget, __assign({}, dialogProps));
        return dialog;
    };
    OpenWorkbookInDesktopDialogContent.prototype.handleCloseClick = function () {
        this.setState({ hideDialog: true });
        this.props.updateWorkbook();
    };
    return OpenWorkbookInDesktopDialogContent;
}(React.PureComponent));
exports.OpenWorkbookInDesktopDialogContent = OpenWorkbookInDesktopDialogContent;
//# sourceMappingURL=DialogContent.js.map